import { Service, ServiceActionType } from '../types';
import { ServiceActionTypes } from '../constants';
import getServiceActionName from './actionName';

export default function actionNoun(
  service: Service,
  actionKey: string,
  typeOf: ServiceActionType = ServiceActionTypes.READ as ServiceActionType
) {
  if (typeOf === ServiceActionTypes.SEARCH_OR_WRITE) {
    // Meta for a search_or_write doesn't contain the nouns of either, so we default to use search
    typeOf = ServiceActionTypes.SEARCH as ServiceActionType;
  }

  const noun = getServiceActionName(service, actionKey, typeOf, {
    hasNoVerb: true,
  });
  return (noun || 'Item').toString();
}
